'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var _tslib = require('../_tslib-bcbe0269.js');

require('@emotion/core');

var React = require('react');

var React__default = _interopDefault(React);

require('../fonts/fonts.js');

require('../base-1dde5d6e.js');

require('../mono-f4fb9dce.js');

require('../colors/colors.js');

require('classnames');

require('../SpaceKitProvider/index.js');

require('../tippy-e2469a97.js');

var index$1 = require('../index-d84dc70c.js');

require('@tippyjs/react');

var mouseRestPlugin = require('./tooltip/mouseRestPlugin.js');
/**
 * Tooltip
 *
 * Intended to show non-essential, non-interactive information after a short
 * delay when hovering on an element. We also wait for the user's cursor to rest
 * on the element; meaning we won't show a Tooltip while the cursor is moving
 */


var Tooltip = function Tooltip(_a) {
  var children = _a.children,
      props = _tslib.__rest(_a, ["children"]);

  return React__default.createElement(index$1.AbstractTooltip, _tslib.__assign({
    delay: 150,
    trigger: "mouseenter",
    plugins: [mouseRestPlugin.mouseRest]
  }, props), children);
};

exports.Tooltip = Tooltip;